import { Injectable} from 'ng-metadata/core';

@Injectable()
export class UUIDGenerator{
    public generateUUID(): string{
        let d = new Date().getTime();
        if(window.performance && typeof window.performance.now === "function"){
            d += performance.now(); //use high-precision timer if available
        }
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=> {
            let r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;   
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/UUIDGenerator.service.ts